import clsx from 'clsx';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

interface PageNotFoundProps {
  /**
   * Overrides the height. The default fills the viewport, which is right for
   * the router's catch-all but overflows inside a shell that already spends
   * height on a top bar — see project-overview-route.tsx.
   */
  className?: string;
}

export const PageNotFound: FC<PageNotFoundProps> = ({ className = 'h-screen' }) => {
  const { t } = useTranslation();
  return (
    <div className={clsx('flex flex-col justify-center items-center text-center', className)}>
      <h1 className="text-4xl font-bold mb-4">{t('page-not-found.title')}</h1>
      <p className="mb-4">{t('page-not-found.subtitle')}</p>
      <Link to="../" className="text-blue-500 hover:underline">
        {t('page-not-found.go-home')}
      </Link>
    </div>
  );
};
